import React from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import BtnBack from '../../../../btn-back'
import { PIM_EMP_WELFARE } from '../../../../../router/routes'
import LabelCustomSmall from '../../../../label-custom-small'
import { Image } from 'react-bootstrap'
import Parking from './../../../../../images/Parking.svg'
import { useSearchParams } from 'react-router-dom'

export default function EmpWelfareCarPark() {
  return (
    <>
      <Card.Body className="overflow-auto">
        <BtnBack text={'สิทธิค่าที่จอดรถ'} className={''} />
        <Row className="mt-3">
          <Col>
            <div className="d-flex">
              <Image
                src={Parking}
                className="me-3"
                style={{
                  height: '45px',
                  width: '45px'
                }}
              ></Image>{' '}
              <span className="my-auto">มีสิทธิ 1,000 บาทต่อเดือน</span>
            </div>
          </Col>
          <Col xl={12}>
            <Row>
              <Form.Group className="mt-3 col-xl-3">
                <LabelCustomSmall>ปี</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3 col-xl-3">
                <LabelCustomSmall>เดือน</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3 col-xl-3">
                <LabelCustomSmall>ราคาเต็มรวม Vat 7% (บาท)</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3 col-xl-3">
                <LabelCustomSmall>ราคาที่บริษัทจ่าย (บาท)</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  )
}
